import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-trino-cream pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-56">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 pointer-events-none opacity-20 flex items-center justify-center" data-id="element-57">
        <svg width="800" height="800" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg" className="animate-[spin_120s_linear_infinite]" data-id="element-58">
          <circle cx="400" cy="400" r="300" stroke="#ffe471" strokeWidth="1" strokeDasharray="4 4" data-id="element-59" />
          <circle cx="400" cy="400" r="200" stroke="#ffe471" strokeWidth="1" data-id="element-60" />
          <path d="M400 100 L660 550 L140 550 Z" stroke="#ffe471" strokeWidth="1" data-id="element-61" />
          <path d="M400 700 L140 250 L660 250 Z" stroke="#ffe471" strokeWidth="1" data-id="element-62" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left" data-id="element-64">
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="inline-block mb-4 px-4 py-1.5 rounded-full border border-trino-gold/50 bg-trino-gold/10 text-trino-gold-dark font-medium text-sm tracking-widest uppercase" data-id="element-65">
            Tu Mapa Sagrado
          </motion.div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-trino-burgundy leading-tight mb-6" data-id="element-66">
            Descubre tu Perfil Trino Express: <br data-id="element-67" />
            <span className="text-trino-gold-dark italic font-light" data-id="element-68">
              El Mapa Sagrado de tu Alma
            </span>
          </h1>
          <p className="text-lg sm:text-xl text-trino-dark/80 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-69">
            La única metodología que fusiona Numerología, Tzolkin Maya y
            Astrología para revelar quién eres realmente y qué viniste a
            manifestar hoy.
          </p>

          <motion.a href="https://unanuevaconciencia.com/cart/47748104421594:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block bg-gradient-to-r from-trino-gold to-trino-gold-dark text-white font-bold text-lg px-8 py-4 rounded-lg shadow-[0_10px_25px_-5px_rgba(212,168,83,0.4)] hover:shadow-[0_15px_30px_-5px_rgba(212,168,83,0.5)] transition-all duration-300" data-id="element-70">
            QUIERO MI PERFIL TRINO AHORA
          </motion.a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md lg:max-w-full flex justify-center" data-id="element-71">
          <motion.div animate={{
          y: [-10, 10, -10]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} className="relative z-10" data-id="element-72">
            <div className="absolute inset-0 bg-trino-coral/20 blur-3xl rounded-full transform scale-110 -z-10" data-id="element-73"></div>
            <img src="https://cdn.magicpatterns.com/uploads/pW31TzCdY9VJbsEL41QE6o/perfil-trino6.png" alt="Perfil Trino Express en Tablet" className="w-full h-auto drop-shadow-2xl rounded-2xl" data-id="element-74" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}